'use strict';

import React, { useState } from 'react';
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
} from '@mui/material';
import { Brand } from '@/lenses/uilenses/theme/colors';
import { PRODUCT_FAMILIES, PRODUCT_FINDER_INTENTS } from '../studyBuilder.config.js';
import { ChoiceLogoTiles } from './ChoiceLogoTiles.jsx';

export function ProductFinderDialog({ open, onClose, onApplyFamily }) {
	const [intentId, setIntentId] = useState(null);

	const suggested = intentId ? PRODUCT_FINDER_INTENTS.find((x) => x.id === intentId) : null;
	const suggestedProduct = suggested ? PRODUCT_FAMILIES.find((p) => p.id === suggested.suggestFamilyId) : null;

	const handleApply = () => {
		if (suggested?.suggestFamilyId) {
			onApplyFamily(suggested.suggestFamilyId);
			setIntentId(null);
			onClose();
		}
	};

	return (
		<Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="body">
			<DialogTitle sx={{ fontWeight: 800, color: Brand.darkModeBlue }}>Help me choose a product line</DialogTitle>
			<DialogContent>
				<Typography variant="body2" sx={{ color: Brand.molecularBlue, mb: 2, lineHeight: 1.65 }}>
					Pick the path that best matches your study. We will suggest a product line you can change anytime.
				</Typography>
				<ChoiceLogoTiles
					options={PRODUCT_FINDER_INTENTS.map((i) => ({
						id: i.id,
						label: i.label,
						description: i.blurb,
						tileLetter: i.tileLetter,
						tileGradient: i.tileGradient,
					}))}
					value={intentId}
					onChange={setIntentId}
					columns={{ xs: 12, sm: 6 }}
					density="comfortable"
					namePrefix="finder-intent"
				/>
				{suggestedProduct && (
					<Box sx={{ mt: 3, p: 2, borderRadius: 2, background: 'rgba(40, 74, 111, 0.06)', border: `1px solid ${Brand.precisionGrey}` }}>
						<Typography variant="subtitle2" sx={{ fontWeight: 800, color: Brand.darkModeBlue, mb: 0.5 }}>
							Suggested: {suggestedProduct.label}
						</Typography>
						<Typography variant="body2" sx={{ color: Brand.molecularBlue }}>
							{suggestedProduct.description}
						</Typography>
					</Box>
				)}
			</DialogContent>
			<DialogActions sx={{ px: 3, pb: 2 }}>
				<Button onClick={onClose} sx={{ color: Brand.molecularBlue }}>
					Close
				</Button>
				<Button
					variant="contained"
					disabled={!suggested}
					onClick={handleApply}
					sx={{ background: Brand.activatedRed, '&:hover': { background: Brand.insightfulOrange }, fontWeight: 700 }}
				>
					Use this product line
				</Button>
			</DialogActions>
		</Dialog>
	);
}
